import { NgModule } from '@angular/core';

import { PickupComponentsModule } from './components';
import { PickupTypesModule } from './pickupTypes';

import { PickupComponent } from './pickup.shared.component';

const modulesToExport: any[] = [
    PickupComponentsModule,
    PickupTypesModule,
];

@NgModule({
    declarations: [
        PickupComponent,
    ],
    imports: [
        ...modulesToExport,
    ],
    exports: [
        PickupComponent,
        ...modulesToExport
    ],
})
export class PickupModule { }
